// Этот файл генерируется автоматически, его не следует редактировать вручную
import animateNumbers from '@/widgets/animateNumbers.js';
import form from '@/widgets/form.js';
import partnerPopup from '@/widgets/partnerPopup.js';
import sliderBlock from '@/widgets/sliderBlock.js';

export default {
  'animateNumbers': async () => { return { default: animateNumbers }; },
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'folder': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/folder.js'),
  'form': async () => { return { default: form }; },
  'mobileMenu': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/mobileMenu.js'),
  'mobileMenuButton': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/mobileMenuButton.js'),
  'partnerPopup': async () => { return { default: partnerPopup }; },
  'scrollTop': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollTop.js'),
  'sliderBlock': async () => { return { default: sliderBlock }; },
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js')
};
